
const proyectosData = [
  {
    id: 6,
    titulo: {
      es: "Logo Personal – CV & Portafolio",
      en: "Personal Logo – CV & Portfolio"
    },
    categoria: ["Diseño Gráfico"],
    descripcion: {
      es: "Diseño de un logotipo personal profesional para CV y portafolio, utilizando Adobe Photoshop e Inkscape.",
      en: "Design of a professional personal logo for CV and portfolio, using Adobe Photoshop and Inkscape."
    },
    imagen: "/images/logo.webp",
    width: 1152,
    height: 885,
    url: "/images/logo.webp",
    fecha: "2025-01-05",
  },
  {
    id: 5,
    titulo: {
      es: "Website Productos Puritico",
      en: "Productos Puritico Website"
    },
    categoria: ["Desarrollo Web"],
    descripcion: {
      es: "Sitio web desarrollado en WordPress para la empresa Productos Puritico, dedicada a la venta de café, pinolillo y chocolate artesanal.",
      en: "Website developed in WordPress for Productos Puritico, dedicated to the sale of coffee, pinolillo, and handmade chocolate."
    },
    imagen: "/images/prprodpuri.webp",
    width: 1150,
    height: 883,
    url: "http://productospuritico.ct.ws",
    fecha: "2024-12-01",
  },
  {
    id: 4,
    titulo: {
      es: "Script para Obtener IP Pública y Privada",
      en: "Script for Public and Private IP"
    },
    categoria: ["Programación"],
    descripcion: {
      es: "Script BAT que obtiene la IP pública y privada del usuario mediante comandos de red. Proyecto sencillo y útil para diagnóstico.",
      en: "BAT script that gets the user's public and private IP using network commands. Simple and useful project for diagnostics."
    },
    imagen: "/images/prscript.webp",
    width: 800,
    height: 615,
    url: "https://github.com/ypikdov/IP-PUBLICA-Y-PRIVADA",
    fecha: "2024-10-10",
  },
  {
    id: 3,
    titulo: {
      es: "Portafolio & CV Personal (React + Vite)",
      en: "Personal Portfolio & CV (React + Vite)"
    },
    categoria: ["Desarrollo Web", "UI/UX"],
    descripcion: {
      es: "Mi portafolio personal creado con React y Vite, alojado en Netlify con integración a Firebase y EmailJS.",
      en: "My personal portfolio created with React and Vite, hosted on Netlify with Firebase and EmailJS integration."
    },
    imagen: "/images/prportafolio.webp",
    width: 600,
    height: 400,
    url: "https://ypikdov.cv",
    fecha: "2024-09-15",
  },
  {
    id: 2,
    titulo: {
      es: "Juego Snake (Web)",
      en: "Snake Game (Web)"
    },
    categoria: ["Juegos"],
    descripcion: {
      es: "Desarrollo del clásico juego Snake usando HTML5, CSS3 y JavaScript puro. Adaptado para móviles y escritorio.",
      en: "Development of the classic Snake game using HTML5, CSS3, and pure JavaScript. Adapted for mobile and desktop."
    },
    imagen: "/images/prsnake.webp",
    width: 600,
    height: 400,
    url: "https://github.com/ypikdov/SNAKE.IO",
    fecha: "2024-08-20",
  },
  {
    id: 1,
    titulo: {
      es: "Juego Tetris (Web)",
      en: "Tetris Game (Web)"
    },
    categoria: ["Juegos"],
    descripcion: {
      es: "Implementación moderna del clásico Tetris usando HTML5, CSS3 y JavaScript, con controles optimizados para teclado.",
      en: "Modern implementation of the classic Tetris using HTML5, CSS3, and JavaScript, with controls optimized for keyboard."
    },
    imagen: "/images/prtetris.webp",
    width: 600,
    height: 400,
    url: "https://github.com/ypikdov/TETRIS",
    fecha: "2024-08-10",
  },
];

// Ordenar de más reciente a más antiguo
const proyectos = proyectosData.sort(
  (a, b) => new Date(b.fecha) - new Date(a.fecha)
);


export default proyectos;